import { Component, OnInit } from '@angular/core';

import { UserService } from '../../services/user/user.service';
import * as jspdf from 'jspdf';
import * as html2canvas from 'html2canvas';
import { User } from '../../models/user.model';

declare function init_plugins();

import { TranslationService } from '../../services/services.index';
import { Router } from '@angular/router';

@Component({
  selector: 'app-certificado-pago',
  templateUrl: './certificado-pago.component.html',
  styles: []
})
export class CertificadoPagoComponent implements OnInit {

  user: User;

  constructor( public _userService: UserService,
    public _translationService: TranslationService,
    public router: Router ) { }

  ngOnInit() {
    init_plugins();
    this.comprobarPagoHabilitado();
    this._userService.getUserActividades().subscribe(resp => {
      this.user = resp;
    });
  }

  comprobarPagoHabilitado() {
    if (!this._userService.user.aprobado) {
      let lang: string = this._translationService.lang;
          let tituloSwal: string;
          let mensajeSwal: string;
          if (lang === 'es') {
            tituloSwal = 'Certificado no habilitados';
            mensajeSwal = 'Podrá imprimir el certificado de pago una vez esté aprobado. Muchas gracias';
          } else {
            tituloSwal = 'Certificate not enabled';
            mensajeSwal = 'You can print the payment certificate once it is approved. Thank you';
          }

          swal(tituloSwal, mensajeSwal, 'error');
          this.router.navigate(['/dashboard']);
    }
  }

  generarPdf() {
      let data = document.getElementById('contentToConvert');
      html2canvas(data).then(canvas => {
      // Few necessary setting options
      let imgWidth = 295;
      let pageHeight = 295;
      let imgHeight = canvas.height * imgWidth / canvas.width;
      let heightLeft = imgHeight;

      const contentDataURL = canvas.toDataURL('image/png');
      let pdf = new jspdf('p', 'mm', 'a4'); // A4 size page of PDF
      let position = 0;
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
      pdf.save('certificado-pago.pdf'); // Generated PDF
  });
  }

  convertirFecha(timestamp: number) {
    return new Date(timestamp);
  }

  capitalize(texto: string) {
    return texto.toLowerCase()
    .split(' ')
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');
  }

  getNombreByLang (objeto: any) {
    if (this._translationService.lang === 'es') {
      objeto.nombre_lang = objeto.nombre_es;
    } else if (this._translationService.lang === 'en') {
      objeto.nombre_lang = objeto.nombre_en;
    }
    return objeto.nombre_lang;
  }

}



// WEBPACK FOOTER //
// ./src/app/certificados/certificado-pago/certificado-pago.component.ts